export interface ChatMessage {
  author: string;
  contents: string;
  created_time?: number;
  id?: number;
  origin: string;
  sequence_id?: number;
}

export interface ChatData {
  chat_id: string;
  chatInfo: ChatInfo;
  messages: ChatMessage[];
  loading: boolean;
  loaded: boolean;
  sending: boolean;
  sent: boolean;
  message?: string;
  error: string;
  unreadMessagesCount: number;
  lastSequenceId: number
}

export interface PusherConnectOptions {
  key: string;
  options: {
    cluster: string;
  }
}

export interface ChatInfo {
  invite_code: string;
  chat_channel: string;
  destination: string;
  description: string
  customer: string;
  id: number;
  org_id: number;
  agent_id: number;
  completed: boolean;
  appointment_id: string;
}

export const mapJobToChatInfo = (job) => {
  return {
    id: job?._id,
    appointment_id: job?.metadata?.find(meta => meta.n === 'appointment_id')?.v || job?.foreign_id || '-',
    invite_code: job?.invite_code,
    chat_channel: `${job?.chat_channel}`,
    destination: job?.destination?.name,
    description: job?.description,
    customer: job?.metadata?.find(meta => meta.n === 'era_recipient_name')?.v || '-',
    org_id: job?.org_id,
    agent_id: job?.agent_id,
    completed: job?.completed
  } as ChatInfo;
};


